import { injectable } from 'inversify';
import { organisation_full } from '@Api';
import { Organisation } from '@Models';

@injectable()
export class OrganisationMapper {
  public map(item: organisation_full): Organisation {
    return {
      id: item.id,
      name: item.name,
      medium_logo: item.medium_logo,
      position: item.position,
    } satisfies Organisation as Organisation;
  }
}
